import { render, staticRenderFns } from "./DetailNormalButton.vue?vue&type=template&id=76d58478&scoped=true&"
import script from "./DetailNormalButton.vue?vue&type=script&lang=js&"
export * from "./DetailNormalButton.vue?vue&type=script&lang=js&"
import style0 from "./DetailNormalButton.vue?vue&type=style&index=0&id=76d58478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d58478",
  null
  
)

export default component.exports